/* ==== 10-header.js ==== */
/* TM header (sections/tm-header.liquid): the two buttons the blue bar shows below 768px, plus the
 * "More" dropdown of raw/states.json.
 * The mobile capture only records the closed state (both buttons carry aria-expanded="false" and the live
 * drawer is rendered by a script that is out of scope), so the clone keeps the captured markup and only
 * reveals the category list and the search field that are already in it. Opening one closes the others.
 * "More" opens on click and closes on a second click, on click outside and on Escape, which returns
 * focus to the button. */
(function () {
  "use strict";

  var menuToggle = document.querySelector("[data-tm-menu-toggle]");
  var menuPanel = document.querySelector("[data-tm-menu-panel]");
  var searchToggle = document.querySelector("[data-tm-search-toggle]");
  var searchPanel = document.querySelector("[data-tm-search-panel]");
  var moreToggle = document.querySelector("[data-tm-more-toggle]");
  var morePanel = document.querySelector("[data-tm-more-panel]");
  if (!menuToggle && !searchToggle && !moreToggle) return;

  function setOpen(toggle, panel, open) {
    if (!toggle || !panel) return;
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    panel.setAttribute("data-open", open ? "true" : "false");
  }

  function isOpen(panel) {
    return !!panel && panel.getAttribute("data-open") === "true";
  }

  /* The panel links stay out of the tab order while it is closed. */
  function setMoreFocusable(open) {
    if (!morePanel) return;
    var links = morePanel.querySelectorAll("a");
    for (var i = 0; i < links.length; i += 1) {
      if (open) links[i].removeAttribute("tabindex");
      else links[i].setAttribute("tabindex", "-1");
    }
  }

  function closeAll() {
    setOpen(menuToggle, menuPanel, false);
    setOpen(searchToggle, searchPanel, false);
    setOpen(moreToggle, morePanel, false);
    setMoreFocusable(false);
  }

  if (menuToggle && menuPanel) {
    menuToggle.addEventListener("click", function () {
      var next = !isOpen(menuPanel);
      closeAll();
      setOpen(menuToggle, menuPanel, next);
    });
  }

  if (searchToggle && searchPanel) {
    searchToggle.addEventListener("click", function () {
      var next = !isOpen(searchPanel);
      closeAll();
      setOpen(searchToggle, searchPanel, next);
      if (next) {
        var input = searchPanel.querySelector("input");
        if (input) input.focus();
      }
    });
  }

  /* "More" panel: opens on click, closes on a second click, on click outside and on Escape. */
  if (moreToggle && morePanel) {
    moreToggle.addEventListener("click", function () {
      var next = !isOpen(morePanel);
      closeAll();
      setOpen(moreToggle, morePanel, next);
      setMoreFocusable(next);
    });
  }

  document.addEventListener("click", function (event) {
    var header = document.querySelector(".tm-header");
    if (!header || header.contains(event.target)) return;
    closeAll();
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape" && event.keyCode !== 27) return;
    var moreWasOpen = isOpen(morePanel);
    closeAll();
    if (moreWasOpen && moreToggle) moreToggle.focus();
  });

  /* The burger and the search field only exist below 768px, so a resize back to the wide layout
   * resets them. The "More" panel belongs to both layouts and keeps its state. */
  window.addEventListener("resize", function () {
    if (window.innerWidth <= 767) return;
    setOpen(menuToggle, menuPanel, false);
    setOpen(searchToggle, searchPanel, false);
  });
})();

/* ==== 11-footer.js ==== */
/* TM footer (sections/tm-footer.liquid): the five link columns become accordions below 768px, exactly like
 * the useState in TmFooter.tsx. One column is open at a time, all are closed on load like in the capture.
 * Above 767px the triggers are inert headings, so the click handler is a no-op there (CSS keeps every panel
 * visible: the [data-open="false"] rule only applies inside the mobile media query). */
(function () {
  "use strict";

  var triggers = document.querySelectorAll(".tm-footer__column-trigger");
  if (!triggers.length) return;

  function panelOf(trigger) {
    var column = trigger.closest ? trigger.closest(".tm-footer__column") : null;
    return column ? column.querySelector(".tm-footer__panel") : null;
  }

  function closeAll() {
    for (var i = 0; i < triggers.length; i += 1) {
      var panel = panelOf(triggers[i]);
      triggers[i].setAttribute("aria-expanded", "false");
      if (panel) panel.setAttribute("data-open", "false");
      var chevron = triggers[i].querySelector(".tm-footer__chevron");
      if (chevron) chevron.classList.remove("tm-footer__chevron-open");
    }
  }

  for (var i = 0; i < triggers.length; i += 1) {
    triggers[i].addEventListener("click", function (event) {
      if (window.innerWidth > 767) return;
      var trigger = event.currentTarget;
      var open = trigger.getAttribute("aria-expanded") === "true";
      closeAll();
      if (open) return;
      var panel = panelOf(trigger);
      trigger.setAttribute("aria-expanded", "true");
      if (panel) panel.setAttribute("data-open", "true");
      var chevron = trigger.querySelector(".tm-footer__chevron");
      if (chevron) chevron.classList.add("tm-footer__chevron-open");
    });
  }
})();

/* ==== 20-tabs.js ==== */
/* TM section tabs (sections/tm-tabs.liquid): port of the useEffect in TmSectionTabs.tsx.
 * The bar itself sticks in CSS; this part only marks the section that is currently under it, the way the
 * original does: an IntersectionObserver watches a 1px band right below the bar, so the active link follows
 * the scroll position rather than the last click. Sections that are not on the page are simply skipped. */
(function () {
  "use strict";

  /* Height of the sticky bar, used as the top of the detection band. */
  var BAR_HEIGHT = 60;

  var bar = document.querySelector("[data-tm-tabs]");
  if (!bar || !window.IntersectionObserver) return;

  var items = bar.querySelectorAll("li[data-section]");
  var tabs = [];
  var i;
  for (i = 0; i < items.length; i += 1) {
    var id = items[i].getAttribute("data-section");
    var section = document.getElementById(id);
    var link = items[i].querySelector(".tm-tabs__link");
    if (section && link) tabs.push({ id: id, link: link, section: section });
  }
  if (!tabs.length) return;

  function setActive(id) {
    for (var j = 0; j < tabs.length; j += 1) {
      if (tabs[j].id === id) {
        tabs[j].link.classList.add("tm-tabs__active");
        tabs[j].link.setAttribute("aria-current", "location");
      } else {
        tabs[j].link.classList.remove("tm-tabs__active");
        tabs[j].link.removeAttribute("aria-current");
      }
    }
  }

  var inBand = [];
  var observer = null;

  function connect() {
    if (observer) observer.disconnect();
    inBand = [];
    /* Collapse the root to a 1px strip immediately under the sticky bar. */
    var bottomInset = Math.max(0, window.innerHeight - BAR_HEIGHT - 2);
    observer = new IntersectionObserver(
      function (entries) {
        for (var k = 0; k < entries.length; k += 1) {
          var entryId = entries[k].target.id;
          var at = inBand.indexOf(entryId);
          if (entries[k].isIntersecting) {
            if (at === -1) inBand.push(entryId);
          } else if (at !== -1) {
            inBand.splice(at, 1);
          }
        }
        /* Above the first section nothing intersects; keep the last known link active. */
        for (var t = 0; t < tabs.length; t += 1) {
          if (inBand.indexOf(tabs[t].id) !== -1) {
            setActive(tabs[t].id);
            return;
          }
        }
      },
      { rootMargin: "-" + (BAR_HEIGHT + 1) + "px 0px -" + bottomInset + "px 0px" }
    );
    for (var s = 0; s < tabs.length; s += 1) observer.observe(tabs[s].section);
  }

  connect();
  window.addEventListener("resize", connect);
})();

/* ==== 30-concerts.js ==== */
/* TM concerts (sections/tm-concerts.liquid): the list / calendar toggle of raw/states.json.
 * The pair of icon buttons writes data-view on the section, which src/tm-css/30-concerts.css uses both
 * to blacken the pressed button and to swap the two blocks of the card. The calendar itself is static
 * markup: only January 2027 carries events, so the month strip has nothing to navigate. */
(function () {
  "use strict";

  var sections = document.querySelectorAll("[data-tm-concerts]");

  for (var i = 0; i < sections.length; i += 1) {
    bind(sections[i]);
  }

  function bind(section) {
    var buttons = section.querySelectorAll("[data-tm-view]");
    if (!buttons.length) return;

    function setView(view) {
      section.setAttribute("data-view", view);
      for (var j = 0; j < buttons.length; j += 1) {
        var pressed = buttons[j].getAttribute("data-tm-view") === view;
        buttons[j].setAttribute("aria-pressed", pressed ? "true" : "false");
      }
    }

    for (var k = 0; k < buttons.length; k += 1) {
      buttons[k].addEventListener("click", function (event) {
        setView(event.currentTarget.getAttribute("data-tm-view"));
      });
    }
  }
})();

/* TM concerts, the "All Dates" range picker of raw/state-dates.json (interactive-states.spec.md, state 3).
 * The panel shell is in sections/tm-concerts.liquid, the day cells are built here because the month arrows
 * re-render both grids. Apply writes "DD/MM/YYYY - DD/MM/YYYY" into the pill, hides the event rows whose
 * data-date falls outside the range and recounts the heading. Everything is guarded: all parts are
 * concatenated into one tm.js, so a thrown error would kill every script after this one. */
(function () {
  "use strict";

  /* The original titles the September grid "Sept 2026", so the abbreviations are not the plain 3 letters. */
  var MONTH_TITLES = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec"
  ];
  var MONTH_NAMES = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];
  /* Monday first, the way the grids are laid out. */
  var WEEKDAYS_LONG = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
  ];
  var DMY = /^\s*(\d{1,2})\/(\d{1,2})\/(\d{4})\s*$/;

  var fields = document.querySelectorAll("[data-tm-dates]");

  for (var i = 0; i < fields.length; i += 1) {
    bindPicker(fields[i]);
  }

  function pad2(value) {
    return value < 10 ? "0" + value : String(value);
  }

  /* month is 0 based, the way Date reports it. */
  function isoOf(year, month, day) {
    return year + "-" + pad2(month + 1) + "-" + pad2(day);
  }

  function dmyOf(iso) {
    var parts = iso.split("-");
    if (parts.length !== 3) return "";
    return parts[2] + "/" + parts[1] + "/" + parts[0];
  }

  /* Typed values are accepted as DD/MM/YYYY; anything that is not a real day returns "". */
  function isoFromDmy(text) {
    var match = DMY.exec(String(text));
    if (!match) return "";
    var day = parseInt(match[1], 10);
    var month = parseInt(match[2], 10);
    var year = parseInt(match[3], 10);
    if (month < 1 || month > 12) return "";
    var probe = new Date(year, month - 1, day);
    if (probe.getFullYear() !== year || probe.getMonth() !== month - 1 || probe.getDate() !== day) {
      return "";
    }
    return isoOf(year, month - 1, day);
  }

  function bindPicker(field) {
    var pill = field.querySelector("[data-tm-dates-toggle]");
    var panel = field.querySelector("[data-tm-dates-panel]");
    var startInput = field.querySelector("[data-tm-dates-start]");
    var endInput = field.querySelector("[data-tm-dates-end]");
    var grids = field.querySelectorAll("[data-tm-dates-grid]");
    var titles = field.querySelectorAll("[data-tm-dates-title]");
    var prevButton = field.querySelector("[data-tm-dates-prev]");
    var nextButton = field.querySelector("[data-tm-dates-next]");
    var resetButton = field.querySelector("[data-tm-dates-reset]");
    var cancelButton = field.querySelector("[data-tm-dates-cancel]");
    var applyButton = field.querySelector("[data-tm-dates-apply]");
    var pillValue = field.querySelector("[data-tm-dates-value]");
    var pillSrText = field.querySelector("[data-tm-dates-sr]");
    var status = field.querySelector("[data-tm-dates-status]");

    if (!pill || !panel || !startInput || !endInput || grids.length < 2 || titles.length < 2) return;
    if (!resetButton || !cancelButton || !applyButton || !nextButton) return;

    var section = field.closest ? field.closest("[data-tm-concerts]") : null;
    var results = section ? section.querySelector("[data-tm-results]") : null;
    var heading = section ? section.querySelector("[data-tm-heading]") : null;
    var rows = section ? section.querySelectorAll(".tm-concerts__event-list > li[data-date]") : [];
    var defaultResultLabel = results ? results.textContent : "";

    var now = new Date();
    var todayIso = isoOf(now.getFullYear(), now.getMonth(), now.getDate());
    /* The pair opens on the current month and never walks back past it, like the original. */
    var baseYear = now.getFullYear();
    var baseMonth = now.getMonth();
    var viewYear = baseYear;
    var viewMonth = baseMonth;

    var draftStart = "";
    var draftEnd = "";
    var appliedStart = "";
    var appliedEnd = "";
    var open = false;

    render();

    pill.addEventListener("click", function () {
      if (open) {
        closePanel();
      } else {
        openPanel();
      }
    });

    nextButton.addEventListener("click", function () {
      shiftMonths(1);
    });

    if (prevButton) {
      prevButton.addEventListener("click", function () {
        shiftMonths(-1);
      });
    }

    resetButton.addEventListener("click", function () {
      draftStart = "";
      draftEnd = "";
      syncInputs();
      render();
      startInput.focus();
    });

    cancelButton.addEventListener("click", function () {
      closePanel();
    });

    applyButton.addEventListener("click", function () {
      appliedStart = draftStart;
      appliedEnd = draftEnd;
      applyFilter();
      closePanel();
    });

    for (var g = 0; g < grids.length; g += 1) {
      grids[g].addEventListener("click", onGridClick);
    }

    startInput.addEventListener("input", onTyped);
    endInput.addEventListener("input", onTyped);

    document.addEventListener("keydown", function (event) {
      if (!open) return;
      if (event.key === "Escape" || event.key === "Esc") {
        closePanel();
        pill.focus();
      }
    });

    /* One document listener for the lifetime of the page: a press inside the field is never "outside",
     * so the pill can toggle without the panel closing underneath it. It listens on mousedown because
     * picking a day rewrites the grid, so by the time a click reached the document the pressed button
     * would already be gone from the field. */
    document.addEventListener("mousedown", function (event) {
      if (!open) return;
      if (field.contains(event.target)) return;
      closePanel();
    });

    function openPanel() {
      open = true;
      draftStart = appliedStart;
      draftEnd = appliedEnd;
      panel.hidden = false;
      pill.setAttribute("aria-expanded", "true");
      syncInputs();
      render();
      startInput.focus();
    }

    /* Closing always behaves like Cancel: the draft goes back to what was applied. */
    function closePanel() {
      open = false;
      draftStart = appliedStart;
      draftEnd = appliedEnd;
      panel.hidden = true;
      pill.setAttribute("aria-expanded", "false");
      syncInputs();
      render();
    }

    function shiftMonths(step) {
      var next = new Date(viewYear, viewMonth + step, 1);
      if (next.getFullYear() < baseYear) return;
      if (next.getFullYear() === baseYear && next.getMonth() < baseMonth) return;
      viewYear = next.getFullYear();
      viewMonth = next.getMonth();
      render();
    }

    function onGridClick(event) {
      var cell = event.target;
      while (cell && cell !== event.currentTarget && !cell.getAttribute("data-tm-dates-day")) {
        cell = cell.parentNode;
      }
      if (!cell || cell === event.currentTarget) return;
      if (cell.disabled) return;

      var iso = cell.getAttribute("data-tm-dates-day");
      if (!draftStart || draftEnd || iso < draftStart) {
        /* First click, a third click after a full range, or a day before the start: start over. */
        draftStart = iso;
        draftEnd = "";
      } else {
        draftEnd = iso;
      }
      syncInputs();
      render();
    }

    /* Typing does not rewrite the inputs, only the grids follow, so the caret stays where it is. */
    function onTyped() {
      draftStart = isoFromDmy(startInput.value);
      draftEnd = isoFromDmy(endInput.value);
      if (draftStart && draftEnd && draftEnd < draftStart) draftEnd = "";
      render();
    }

    function syncInputs() {
      startInput.value = draftStart ? dmyOf(draftStart) : "";
      endInput.value = draftEnd ? dmyOf(draftEnd) : "";
    }

    function render() {
      renderMonth(0, viewYear, viewMonth);
      var second = new Date(viewYear, viewMonth + 1, 1);
      renderMonth(1, second.getFullYear(), second.getMonth());

      if (prevButton) {
        prevButton.hidden = viewYear === baseYear && viewMonth === baseMonth;
      }
    }

    function renderMonth(index, year, month) {
      titles[index].textContent = MONTH_TITLES[month] + " " + year;

      var lead = (new Date(year, month, 1).getDay() + 6) % 7;
      var days = new Date(year, month + 1, 0).getDate();
      var html = "";
      var day;

      for (day = 0; day < lead; day += 1) {
        html += "<span></span>";
      }

      for (day = 1; day <= days; day += 1) {
        var iso = isoOf(year, month, day);
        var past = iso < todayIso;
        var className = "tm-concerts__dp-day";
        if (iso === todayIso) className += " tm-concerts__dp-day-today";
        if (iso === draftStart || (draftEnd && iso === draftEnd)) {
          className += " tm-concerts__dp-day-selected";
        } else if (draftStart && draftEnd && iso > draftStart && iso < draftEnd) {
          className += " tm-concerts__dp-day-in-range";
        }

        var label = WEEKDAYS_LONG[(lead + day - 1) % 7] + " " + day + " " + MONTH_NAMES[month];
        html +=
          '<button type="button" class="' +
          className +
          '"' +
          (past ? " disabled" : "") +
          ' data-tm-dates-day="' +
          iso +
          '"><span aria-hidden="true">' +
          day +
          '</span><span class="tm-visually-hidden">' +
          (past ? "disabled, " : "") +
          label +
          "</span></button>";
      }

      grids[index].innerHTML = html;
    }

    /* Apply writes the pill label and filters the list. An open ended range (only a start typed or
     * picked) is allowed and reads as the single date, the spec only pins down the two sided case. */
    function applyFilter() {
      var label = "All Dates";
      if (appliedStart && appliedEnd) {
        label = dmyOf(appliedStart) + " - " + dmyOf(appliedEnd);
      } else if (appliedStart) {
        label = dmyOf(appliedStart);
      } else if (appliedEnd) {
        label = dmyOf(appliedEnd);
      }

      if (pillValue) pillValue.textContent = label;
      if (pillSrText) pillSrText.textContent = "Dates. Change date range: " + label;
      if (status) status.textContent = "Current date range: " + label;

      var visible = 0;
      for (var r = 0; r < rows.length; r += 1) {
        var date = rows[r].getAttribute("data-date");
        var inRange = true;
        if (appliedStart && date < appliedStart) inRange = false;
        if (appliedEnd && date > appliedEnd) inRange = false;
        rows[r].hidden = !inRange;
        if (inRange) visible += 1;
      }

      if (!results) return;
      if (!appliedStart && !appliedEnd) {
        results.textContent = defaultResultLabel;
      } else {
        results.textContent = visible === 1 ? "1 result" : visible + " results";
      }
      if (heading) heading.setAttribute("aria-label", "Concerts, " + results.textContent);
    }
  }
})();

/* ==== 40-gallery.js ==== */
/* TM gallery (sections/tm-gallery.liquid): port of the client logic in TmGallery.tsx.
 * The track scroll snaps in CSS; this part measures which slides sit fully inside the track, disables the
 * arrows at both ends, moves the row by exactly one slide per click and writes the "1, 2, 3 and 4 of 5"
 * counter plus its aria-live twin. */
(function () {
  "use strict";

  var carousel = document.querySelector("[data-tm-gallery]");
  if (!carousel) return;

  var track = carousel.querySelector("[data-tm-gallery-track]");
  var prev = carousel.querySelector("[data-tm-gallery-prev]");
  var next = carousel.querySelector("[data-tm-gallery-next]");
  var counter = carousel.querySelector("[data-tm-gallery-counter]");
  var status = carousel.querySelector("[data-tm-gallery-status]");
  if (!track) return;

  var total = track.children.length;

  /* "1, 2, 3 and 4" for the slide numbers currently in view. */
  function joinSlides(numbers) {
    if (numbers.length === 0) return "";
    if (numbers.length === 1) return String(numbers[0]);
    return numbers.slice(0, -1).join(", ") + " and " + numbers[numbers.length - 1];
  }

  function measure() {
    var box = track.getBoundingClientRect();
    var inView = [];
    for (var i = 0; i < track.children.length; i += 1) {
      var slide = track.children[i].getBoundingClientRect();
      if (slide.left >= box.left - 1 && slide.right <= box.right + 1) inView.push(i + 1);
    }
    var atStart = track.scrollLeft <= 1;
    var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
    if (prev) prev.setAttribute("aria-disabled", atStart ? "true" : "false");
    if (next) next.setAttribute("aria-disabled", atEnd ? "true" : "false");

    var list = joinSlides(inView);
    if (counter) counter.textContent = list ? list + " of " + total : "";
    if (status) status.textContent = list ? "Showing slide " + list + " of " + total : "";
  }

  function move(direction) {
    var first = track.children[0];
    var second = track.children[1];
    if (!first) return;
    var step = second
      ? second.getBoundingClientRect().left - first.getBoundingClientRect().left
      : first.getBoundingClientRect().width;
    if (track.scrollBy) track.scrollBy({ left: direction * step, behavior: "smooth" });
    else track.scrollLeft += direction * step;
  }

  if (prev) {
    prev.addEventListener("click", function () {
      if (prev.getAttribute("aria-disabled") !== "true") move(-1);
    });
  }
  if (next) {
    next.addEventListener("click", function () {
      if (next.getAttribute("aria-disabled") !== "true") move(1);
    });
  }

  track.addEventListener("scroll", measure);

  /* ResizeObserver fires once right after observe(), which covers the first measurement as well as every
   * later viewport change. Without it (older browsers) load and resize do the same job. */
  if (window.ResizeObserver) {
    var observer = new ResizeObserver(function () {
      measure();
    });
    observer.observe(track);
  } else {
    window.addEventListener("resize", measure);
    window.addEventListener("load", measure);
    measure();
  }
})();

/* ==== 41-about.js ==== */
/* TM about (sections/tm-about.liquid): the collapse pill, port of the useState in TmAbout.tsx.
 * The block renders expanded, exactly as the capture shows it, so the pill starts on "Show less". */
(function () {
  "use strict";

  var toggle = document.querySelector("[data-tm-about-toggle]");
  var panel = document.querySelector("[data-tm-about-panel]");
  if (!toggle || !panel) return;

  var label = toggle.querySelector("[data-tm-about-label]");
  var chevron = toggle.querySelector(".tm-about__chevron");

  toggle.addEventListener("click", function () {
    var expanded = toggle.getAttribute("aria-expanded") === "true";
    var next = !expanded;
    toggle.setAttribute("aria-expanded", next ? "true" : "false");
    if (label) label.textContent = next ? "Show less" : "Show more";
    if (next) {
      panel.classList.remove("tm-about__body-collapsed");
      if (chevron) chevron.classList.add("tm-about__chevron-up");
    } else {
      panel.classList.add("tm-about__body-collapsed");
      if (chevron) chevron.classList.remove("tm-about__chevron-up");
    }
  });
})();

/* ==== 42-faqs.js ==== */
/* TM faqs (sections/tm-faqs.liquid): the accordion rows, port of the useState in TmFaqs.tsx.
 * One row is open at a time, all rows are closed on load like in the capture, and the panels keep their
 * answers in the markup while collapsed (hidden attribute), exactly as the original does. */
(function () {
  "use strict";

  var list = document.querySelector("[data-tm-faqs]");
  if (!list) return;

  var toggles = list.querySelectorAll("[data-tm-faq-toggle]");
  if (!toggles.length) return;

  function panelOf(toggle) {
    var id = toggle.getAttribute("aria-controls");
    return id ? document.getElementById(id) : null;
  }

  function close(toggle) {
    var panel = panelOf(toggle);
    toggle.setAttribute("aria-expanded", "false");
    if (panel) panel.hidden = true;
    var chevron = toggle.querySelector(".tm-faqs__chevron");
    if (chevron) chevron.classList.remove("tm-faqs__chevron-open");
  }

  for (var i = 0; i < toggles.length; i += 1) {
    toggles[i].addEventListener("click", function (event) {
      var toggle = event.currentTarget;
      var open = toggle.getAttribute("aria-expanded") === "true";
      for (var j = 0; j < toggles.length; j += 1) close(toggles[j]);
      if (open) return;
      var panel = panelOf(toggle);
      toggle.setAttribute("aria-expanded", "true");
      if (panel) panel.hidden = false;
      var chevron = toggle.querySelector(".tm-faqs__chevron");
      if (chevron) chevron.classList.add("tm-faqs__chevron-open");
    });
  }
})();

/* ==== 45-drawer.js ==== */
/* TM drawers (sections/tm-drawers.liquid): the four sheets the header controls open, measured in
 * docs/research/ticketmaster-ie-69b12c46/shared/DRAWERS.md.
 * Triggers carry data-tm-drawer-open with the drawer key: the burger of the blue artist header opens the
 * dark site navigation drawer, the burger of the event header the white Menu sheet, the country button of
 * both headers the Location sheet, the "More Info" and "Accessible Tickets" pills the two event sheets,
 * the "Important Info" band the same Event Info sheet, and the info icon of a concerts row the shared
 * Event Information panel, which is filled from the data-row-* attributes of the row you pressed.
 * One drawer is open at a time, the page dims and stops scrolling behind it, focus moves into the sheet
 * and comes back to the trigger on close, and Escape, the back chevron and a click on the dim all close.
 * The Menu accordions open one at a time, like the FAQ rows in 42-faqs.js. */
(function () {
  "use strict";

  var root = document.querySelector("[data-tm-drawers]");
  if (!root) return;

  var scrim = root.querySelector("[data-tm-drawer-scrim]");
  var drawers = root.querySelectorAll("[data-tm-drawer]");
  var triggers = document.querySelectorAll("[data-tm-drawer-open]");
  if (!drawers.length) return;

  var openDrawer = null;
  var lastTrigger = null;

  /* Focus without scrolling: a sheet that is still translated off screen would otherwise drag the whole
   * page across as the browser brings the focused control into view. */
  function focusQuietly(node) {
    if (!node || typeof node.focus !== "function") return;
    try {
      node.focus({ preventScroll: true });
    } catch (e) {
      node.focus();
    }
  }

  function drawerByKey(key) {
    for (var i = 0; i < drawers.length; i += 1) {
      if (drawers[i].getAttribute("data-tm-drawer") === key) return drawers[i];
    }
    return null;
  }

  /* Every trigger of the closed drawer reports collapsed, so a page with two headers stays in sync. */
  function syncTriggers() {
    for (var i = 0; i < triggers.length; i += 1) {
      var key = triggers[i].getAttribute("data-tm-drawer-open");
      var isOpen = !!openDrawer && openDrawer.getAttribute("data-tm-drawer") === key;
      triggers[i].setAttribute("aria-expanded", isOpen ? "true" : "false");
    }
  }

  function lockPage(locked) {
    var html = document.documentElement;
    if (!html) return;
    if (locked) html.classList.add("tm-drawer-locked");
    else html.classList.remove("tm-drawer-locked");
  }

  /* One panel serves every concerts row, so its slots are filled from the trigger on open. The tone of
   * the availability bar is one of good, low or limited, the values 30-concerts.css styles. */
  function fillRow(drawer, trigger) {
    var slots = drawer.querySelectorAll("[data-tm-row-slot]");
    if (!slots.length) return;
    for (var i = 0; i < slots.length; i += 1) {
      var key = slots[i].getAttribute("data-tm-row-slot");
      var value = trigger ? trigger.getAttribute("data-row-" + key) : null;
      slots[i].textContent = value || "";
    }

    var url = trigger ? trigger.getAttribute("data-row-url") : null;
    var links = drawer.querySelectorAll("[data-tm-row-cta]");
    for (var j = 0; j < links.length; j += 1) links[j].setAttribute("href", url || "#");

    /* The venue name at the foot links to the venue page, not to the event, the way the capture shows it. */
    var venueUrl = trigger ? trigger.getAttribute("data-row-venue-url") : null;
    var venueLinks = drawer.querySelectorAll("[data-tm-row-venue-link]");
    for (var v = 0; v < venueLinks.length; v += 1) venueLinks[v].setAttribute("href", venueUrl || url || "#");

    var badge = drawer.querySelector("[data-tm-row-badge]");
    var bar = drawer.querySelector("[data-tm-row-badge-bar]");
    var availability = trigger ? trigger.getAttribute("data-row-availability") : null;
    if (badge) badge.hidden = !availability;
    if (bar) {
      var tone = (trigger && trigger.getAttribute("data-row-tone")) || "limited";
      bar.className = "tm-drawer__row-badge-bar tm-drawer__row-badge-bar-" + tone;
    }
  }

  function close(returnFocus) {
    if (!openDrawer) return;
    openDrawer.setAttribute("data-open", "false");
    openDrawer = null;
    if (scrim) scrim.setAttribute("data-open", "false");
    lockPage(false);
    syncTriggers();
    if (returnFocus) focusQuietly(lastTrigger);
    lastTrigger = null;
  }

  function open(key, trigger) {
    var drawer = drawerByKey(key);
    if (!drawer) return;
    if (openDrawer === drawer) {
      close(true);
      return;
    }
    close(false);
    openDrawer = drawer;
    lastTrigger = trigger || null;
    drawer.setAttribute("data-open", "true");
    fillRow(drawer, trigger);
    if (scrim) {
      scrim.setAttribute("data-open", "true");
      /* nav-drawer.json records the site navigation cover at rgba(0,0,0,0.75), the others at 0.5. */
      var dim = drawer.getAttribute("data-tm-drawer-dim");
      if (dim) scrim.setAttribute("data-dim", dim);
      else scrim.removeAttribute("data-dim");
    }
    lockPage(true);
    syncTriggers();
    /* The scrollable body carries tabindex="-1", so focus lands inside the sheet without moving it
     * onto the back button, which would read as "Back" before the title. */
    var body = drawer.querySelector("[data-tm-drawer-body]");
    focusQuietly(body);
  }

  for (var t = 0; t < triggers.length; t += 1) {
    triggers[t].addEventListener("click", function (event) {
      var trigger = event.currentTarget;
      event.preventDefault();
      open(trigger.getAttribute("data-tm-drawer-open"), trigger);
    });
  }

  var closers = root.querySelectorAll("[data-tm-drawer-close]");
  for (var c = 0; c < closers.length; c += 1) {
    closers[c].addEventListener("click", function () {
      close(true);
    });
  }

  if (scrim) {
    scrim.addEventListener("click", function () {
      close(true);
    });
  }

  /* Escape closes, and Tab stays inside the open sheet because it is an aria-modal dialog. */
  document.addEventListener("keydown", function (event) {
    if (!openDrawer) return;
    if (event.key === "Escape" || event.keyCode === 27) {
      close(true);
      return;
    }
    if (event.key !== "Tab" && event.keyCode !== 9) return;
    var focusable = openDrawer.querySelectorAll("a[href], button, input, [tabindex]");
    var list = [];
    for (var i = 0; i < focusable.length; i += 1) {
      if (focusable[i].offsetParent !== null || focusable[i] === document.activeElement) list.push(focusable[i]);
    }
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      focusQuietly(last);
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      focusQuietly(first);
    }
  });

  /* Category accordions of the Menu sheet and of the site navigation sheet: one row open at a time per
   * sheet, all closed on load like the captures. */
  function panelOf(toggle) {
    var id = toggle.getAttribute("aria-controls");
    return id ? document.getElementById(id) : null;
  }

  function closeRow(toggle) {
    toggle.setAttribute("aria-expanded", "false");
    var panel = panelOf(toggle);
    if (panel) panel.hidden = true;
  }

  function bindAccordion(accordion) {
    var rows = accordion.querySelectorAll("[data-tm-menu-toggle-row]");
    for (var r = 0; r < rows.length; r += 1) {
      rows[r].addEventListener("click", function (event) {
        var toggle = event.currentTarget;
        var wasOpen = toggle.getAttribute("aria-expanded") === "true";
        for (var j = 0; j < rows.length; j += 1) closeRow(rows[j]);
        if (wasOpen) return;
        toggle.setAttribute("aria-expanded", "true");
        var panel = panelOf(toggle);
        if (panel) panel.hidden = false;
      });
    }
  }

  var accordions = root.querySelectorAll("[data-tm-menu-accordion]");
  for (var a = 0; a < accordions.length; a += 1) bindAccordion(accordions[a]);

  /* "Countries" group of the Location drawer collapses on its own chevron, open on load. */
  var countryToggle = root.querySelector("[data-tm-country-toggle]");
  if (countryToggle) {
    countryToggle.addEventListener("click", function () {
      var wasOpen = countryToggle.getAttribute("aria-expanded") === "true";
      countryToggle.setAttribute("aria-expanded", wasOpen ? "false" : "true");
      var id = countryToggle.getAttribute("aria-controls");
      var list = id ? document.getElementById(id) : null;
      if (list) list.hidden = wasOpen;
    });
  }
})();

/* ==== 46-misc.js ==== */
/* Two controls that belong to no single section.
 *
 * "Manage my cookies" appears twice, in the footer and in the Menu drawer. On ticketmaster.ie it reopens
 * the consent preferences; on a Shopify storefront that is the privacy banner API, so the button asks for
 * it and stays quiet when the shop has no banner.
 *
 * The heart in the hero saves the artist. The original needs an account for that, so the clone only keeps
 * the pressed state of the button, which is what the capture shows. */
(function () {
  "use strict";

  var cookieButtons = document.querySelectorAll("[data-tm-cookie-preferences]");
  for (var i = 0; i < cookieButtons.length; i += 1) {
    cookieButtons[i].addEventListener("click", function () {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === "function") {
        window.privacyBanner.showPreferences();
        return;
      }
      /* Older storefronts expose the same panel through the consent tracking API. */
      if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.showPreferences === "function") {
        window.Shopify.customerPrivacy.showPreferences();
      }
    });
  }

  var favourite = document.querySelector("[data-tm-favourite]");
  if (!favourite) return;

  favourite.addEventListener("click", function () {
    var saved = favourite.getAttribute("aria-pressed") === "true";
    favourite.setAttribute("aria-pressed", saved ? "false" : "true");
  });
})();

/* ==== 50-event.js ==== */
/* TM event ticket picker (sections/tm-event-tickets.liquid): the five overlays the panel opens over the
 * ticket column, the two filter checkbox lists, the quantity stepper, the single ticket type rule and the
 * basket count they drive. Port of the useState in
 * src/components/sites/ticketmaster-ie-69b12c46/event-18006511A477B6F0-3805cada/TmEventTickets.tsx.
 * States measured in raw/states.json and the six state-*.png captures of 8 September 2026.
 * The capture starts at two Full Price tickets, the stepper clamps to 0 and to the event ticket limit
 * (6), and the green button is disabled while the basket is empty. Unlike the Next clone the button is a real
 * purchase here: it adds the chosen row's variant to the Shopify cart and opens /cart.
 * The filter pills no longer carry a tooltip: no state in states.json shows one, the pills open an
 * overlay instead. */
(function () {
  "use strict";

  var panel = document.querySelector("[data-tm-event-tickets]");
  if (!panel) return;

  var limit = parseInt(panel.getAttribute("data-ticket-limit"), 10);
  if (isNaN(limit) || limit < 1) limit = 6;

  var basketLabel = panel.getAttribute("data-basket-label") || "tickets in basket";
  var basketText = panel.querySelector("[data-tm-basket-text]");
  var basketValue = panel.querySelector("[data-tm-basket-value]");
  var findButton = panel.querySelector("[data-tm-find-tickets]");
  var filterRow = panel.querySelector("[data-tm-filters]");
  var toast = panel.querySelector("[data-tm-toast]");
  var toastClose = panel.querySelector("[data-tm-toast-close]");
  var rows = panel.querySelectorAll("[data-tm-row]");
  var overlays = panel.querySelectorAll("[data-tm-overlay]");
  var openers = panel.querySelectorAll("[data-tm-overlay-open]");
  var closers = panel.querySelectorAll("[data-tm-overlay-close]");

  /* The row holding the basket, null while nothing has been picked with a Select button. */
  var selected = null;
  /* The control that opened the overlay on screen, so focus goes back to it on close. */
  var opener = null;

  /* Basket and stepper ---------------------------------------------------- */

  function valueOf(row) {
    if (!row) return null;
    return row.querySelector("[data-tm-stepper-value]");
  }

  function readValue(row) {
    var value = valueOf(row);
    if (!value) return 0;
    var current = parseInt(value.getAttribute("aria-valuenow"), 10);
    return isNaN(current) ? 0 : current;
  }

  function refreshBasket() {
    var total = 0;
    for (var i = 0; i < rows.length; i += 1) total += readValue(rows[i]);
    if (basketText) basketText.textContent = total + " " + basketLabel;
    if (basketValue) basketValue.textContent = "×" + total;
    if (findButton) findButton.disabled = total === 0;
  }

  function writeValue(row, next) {
    var value = valueOf(row);
    if (!value) return 0;
    var clamped = next;
    if (clamped < 0) clamped = 0;
    if (clamped > limit) clamped = limit;
    value.setAttribute("aria-valuenow", String(clamped));
    value.setAttribute("aria-valuetext", String(clamped));
    value.setAttribute(
      "aria-label",
      value.getAttribute("data-name") +
        " " +
        value.getAttribute("data-price-label") +
        ", current value " +
        clamped
    );
    value.textContent = String(clamped);
    return clamped;
  }

  function setMode(row, mode) {
    if (!row) return;
    var action = row.querySelector("[data-tm-action]");
    if (action) action.setAttribute("data-mode", mode);
  }

  /* Single ticket type rule ----------------------------------------------- */

  var toastText = panel.querySelector("[data-tm-toast-text]");

  function showToast(show, which) {
    if (!toast) return;
    if (show && toastText) {
      var message = toastText.getAttribute("data-" + (which || "combine"));
      if (message) toastText.textContent = message;
    }
    toast.hidden = !show;
  }

  /* The event's allowance is spent, which the stepper cannot know on its own. */
  function showLimitReached() {
    showToast(true, "limit");
  }

  /* Pressing Select puts one row in the basket at 1, turns every other row back into a Select button and
   * hides the filter pills, so the delivery line moves up under the heading. */
  function selectRow(row) {
    if (!row) return;
    for (var i = 0; i < rows.length; i += 1) {
      if (rows[i] === row) continue;
      writeValue(rows[i], 0);
      setMode(rows[i], "select");
    }
    setMode(row, "stepper");
    writeValue(row, 1);
    selected = row;
    if (filterRow) filterRow.hidden = true;
    showToast(true);
    refreshBasket();
  }

  /* Stepping the selected row back to 0 restores the Select buttons and the filter pills. Each row goes
   * back to the control it was authored with, at 0: the tickets the basket held were given up. */
  function clearSelection() {
    for (var i = 0; i < rows.length; i += 1) {
      writeValue(rows[i], 0);
      setMode(rows[i], rows[i].getAttribute("data-initial-control") || "select");
    }
    selected = null;
    if (filterRow) filterRow.hidden = false;
    showToast(false);
    refreshBasket();
  }

  function step(row, delta) {
    var next = writeValue(row, readValue(row) + delta);
    if (next === 0 && selected === row) {
      clearSelection();
      return;
    }
    refreshBasket();
  }

  for (var r = 0; r < rows.length; r += 1) {
    (function (row) {
      var stepper = row.querySelector("[data-tm-stepper]");
      var value = valueOf(row);
      var select = row.querySelector("[data-tm-select]");

      if (stepper && value) {
        var buttons = stepper.querySelectorAll("[data-tm-step]");
        for (var j = 0; j < buttons.length; j += 1) {
          buttons[j].addEventListener("click", function (event) {
            var delta = parseInt(event.currentTarget.getAttribute("data-tm-step"), 10);
            if (isNaN(delta)) return;
            step(row, delta);
          });
        }

        value.addEventListener("keydown", function (event) {
          if (event.key === "ArrowUp" || event.key === "ArrowRight") {
            event.preventDefault();
            step(row, 1);
          }
          if (event.key === "ArrowDown" || event.key === "ArrowLeft") {
            event.preventDefault();
            step(row, -1);
          }
        });
      }

      if (select) {
        select.addEventListener("click", function () {
          selectRow(row);
        });
      }
    })(rows[r]);
  }

  if (toastClose) {
    toastClose.addEventListener("click", function () {
      showToast(false);
    });
  }

  refreshBasket();

  /* Checkout -------------------------------------------------------------- */

  /* The panel sells one ticket type at a time, so the basket is whichever row carries a quantity. Nothing has been
   * pressed on load, so `selected` is null while the capture's two Full Price tickets already sit in the basket:
   * fall back to a scan of the rows. */
  function basketRow() {
    if (selected) return selected;
    for (var i = 0; i < rows.length; i += 1) {
      if (readValue(rows[i]) > 0) return rows[i];
    }
    return null;
  }

  /* The block setting holds the numeric variant id; a gid ends in the same digits, so both forms are accepted. */
  function variantIdOf(row) {
    if (!row) return "";
    var raw = row.getAttribute("data-variant-id");
    if (!raw) return "";
    var match = raw.match(/\d+$/);
    return match ? match[0] : "";
  }

  /* The green button adds the chosen ticket type to the cart and shows the cart. A row with no variant id has no
   * product behind it yet: do nothing at all rather than send the visitor to an empty cart. On a failed add the
   * button goes back to enabled and the page stays where it is, so the visitor can try again. */
  if (findButton) {
    /* The panel's own stepper stops at the limit, but a basket filled on an earlier visit is invisible to
     * it, so the Add checks the real cart first and only adds what is left of this event's allowance. */
    function eventVariantIds() {
      var raw = panel.getAttribute("data-event-variants") || "";
      var ids = raw.split(",");
      var out = [];
      for (var i = 0; i < ids.length; i += 1) {
        var id = ids[i].replace(/^\s+|\s+$/g, "");
        if (id) out.push(id);
      }
      return out;
    }

    function alreadyInCart(callback) {
      var ids = eventVariantIds();
      if (!ids.length) return callback(0);
      fetch("/cart.js", { headers: { Accept: "application/json" } }).then(
        function (response) {
          if (!response || !response.ok) return callback(0);
          response.json().then(
            function (cart) {
              var held = 0;
              var items = (cart && cart.items) || [];
              for (var i = 0; i < items.length; i += 1) {
                for (var j = 0; j < ids.length; j += 1) {
                  if (String(items[i].variant_id) === ids[j]) held += items[i].quantity;
                }
              }
              callback(held);
            },
            function () { callback(0); }
          );
        },
        function () { callback(0); }
      );
    }

    findButton.addEventListener("click", function () {
      var row = basketRow();
      var quantity = readValue(row);
      var variantId = variantIdOf(row);
      if (!variantId || quantity < 1) return;
      findButton.disabled = true;
      alreadyInCart(function (held) {
        var room = limit - held;
        if (room < 1) {
          /* The allowance is already spent: say so on the toast the panel already has and go no further. */
          findButton.disabled = false;
          showLimitReached();
          return;
        }
        addToCart(variantId, quantity > room ? room : quantity);
      });
    });

    function addToCart(variantId, quantity) {
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
      }).then(
        function (response) {
          if (!response || !response.ok) {
            findButton.disabled = false;
            return;
          }
          window.location = "/cart";
        },
        function () {
          findButton.disabled = false;
        }
      );
    }
  }

  /* Overlays -------------------------------------------------------------- */

  /* Focus without scrolling: a sheet that is still translated off screen would otherwise drag the whole
   * page across as the browser brings the focused control into view. */
  function focusQuietly(node) {
    if (!node || typeof node.focus !== "function") return;
    try {
      node.focus({ preventScroll: true });
    } catch (e) {
      node.focus();
    }
  }

  function overlayNamed(name) {
    for (var i = 0; i < overlays.length; i += 1) {
      if (overlays[i].getAttribute("data-tm-overlay") === name) return overlays[i];
    }
    return null;
  }

  /* data-open rather than the hidden attribute, so the sheet stays in the box tree and can slide out as
   * well as in. Its visibility is handled in CSS, which also keeps it out of the tab order while closed. */
  function setOverlayOpen(overlay, open) {
    overlay.setAttribute("data-open", open ? "true" : "false");
    overlay.setAttribute("aria-hidden", open ? "false" : "true");
  }

  function closeOverlay() {
    for (var i = 0; i < overlays.length; i += 1) setOverlayOpen(overlays[i], false);
    for (var j = 0; j < openers.length; j += 1) {
      if (openers[j].hasAttribute("aria-expanded")) openers[j].setAttribute("aria-expanded", "false");
    }
    focusQuietly(opener);
    opener = null;
  }

  /* The More Info overlay carries one card per ticket block, and the pressed info button picks its own. */
  function showInfoPanel(blockId) {
    var overlay = overlayNamed("info");
    if (!overlay) return;
    var panels = overlay.querySelectorAll("[data-tm-info-panel]");
    for (var i = 0; i < panels.length; i += 1) {
      panels[i].hidden = panels[i].getAttribute("data-tm-info-panel") !== blockId;
    }
  }

  /* Only one overlay is open at a time, so opening one hides the other four. */
  function openOverlay(name, trigger) {
    var overlay = overlayNamed(name);
    if (!overlay) return;
    for (var i = 0; i < overlays.length; i += 1) setOverlayOpen(overlays[i], false);
    for (var j = 0; j < openers.length; j += 1) {
      if (openers[j].hasAttribute("aria-expanded")) openers[j].setAttribute("aria-expanded", "false");
    }
    opener = trigger || null;
    setOverlayOpen(overlay, true);
    if (trigger && trigger.hasAttribute("aria-expanded")) trigger.setAttribute("aria-expanded", "true");
    var back = overlay.querySelector("[data-tm-overlay-close]");
    focusQuietly(back);
  }

  for (var o = 0; o < openers.length; o += 1) {
    openers[o].addEventListener("click", function (event) {
      var trigger = event.currentTarget;
      if (!trigger) return;
      var name = trigger.getAttribute("data-tm-overlay-open");
      if (!name) return;
      var target = trigger.getAttribute("data-tm-info-target");
      if (target) showInfoPanel(target);
      openOverlay(name, trigger);
    });
  }

  for (var c = 0; c < closers.length; c += 1) {
    closers[c].addEventListener("click", closeOverlay);
  }

  /* Escape closes the open overlay, exactly like the back chevron. */
  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;
    for (var i = 0; i < overlays.length; i += 1) {
      if (!overlays[i].hidden) {
        closeOverlay();
        return;
      }
    }
  });

  /* Filter overlays ------------------------------------------------------- */

  /* Applying writes the choice into the pill: one option becomes its own label, several become "N Prices"
   * or "N Sections", none puts the default label back. The three rows we clone are not filtered, the
   * original lists more of them than this event carries. */
  function wireFilter(overlay) {
    if (!overlay) return;
    var key = overlay.getAttribute("data-tm-overlay");
    var plural = overlay.getAttribute("data-plural") || "";
    var boxes = overlay.querySelectorAll("[data-tm-filter-option]");
    var selectAll = overlay.querySelector("[data-tm-filter-all]");
    var clearAll = overlay.querySelector("[data-tm-filter-none]");
    var reset = overlay.querySelector("[data-tm-filter-reset]");
    var apply = overlay.querySelector("[data-tm-filter-apply]");
    var pill = panel.querySelector('[data-tm-pill="' + key + '"]');
    if (!boxes.length) return;

    function checkedValues() {
      var picked = [];
      for (var i = 0; i < boxes.length; i += 1) {
        if (boxes[i].checked) picked.push(boxes[i].value);
      }
      return picked;
    }

    /* Clear All, Reset and Apply Filters stay grey and inert until at least one box is checked. */
    function refreshControls() {
      var any = checkedValues().length > 0;
      if (clearAll) clearAll.disabled = !any;
      if (reset) reset.disabled = !any;
      if (apply) apply.disabled = !any;
    }

    function setAll(checked) {
      for (var i = 0; i < boxes.length; i += 1) boxes[i].checked = checked;
      refreshControls();
    }

    for (var b = 0; b < boxes.length; b += 1) {
      boxes[b].addEventListener("change", refreshControls);
    }

    if (selectAll) {
      selectAll.addEventListener("click", function () {
        setAll(true);
      });
    }

    if (clearAll) {
      clearAll.addEventListener("click", function () {
        setAll(false);
      });
    }

    if (reset) {
      reset.addEventListener("click", function () {
        setAll(false);
      });
    }

    if (apply) {
      apply.addEventListener("click", function () {
        var picked = checkedValues();
        if (pill) {
          var label = pill.getAttribute("data-default-label") || pill.textContent;
          if (picked.length === 1) label = picked[0];
          if (picked.length > 1) label = picked.length + " " + plural;
          pill.textContent = label;
        }
        closeOverlay();
      });
    }

    refreshControls();
  }

  for (var f = 0; f < overlays.length; f += 1) {
    if (overlays[f].querySelector("[data-tm-filter-apply]")) wireFilter(overlays[f]);
  }
})();

/* ==== 60-cart.js ==== */
/* The hold on the basket in the checkout bar (sections/tm-cart.liquid). The original counts down a real
 * server side hold; the clone has none, so the deadline is kept in sessionStorage against the cart's own
 * token. That means a reload continues the same countdown instead of handing out a fresh quarter of an
 * hour, and a different basket starts its own. When it reaches zero the visitor goes where the section's
 * timeout url points, which is what the original's timesOutRedirectURL does. */
(function () {
  "use strict";

  var timer = document.querySelector("[data-tm-checkout-timer]");
  if (!timer) return;

  var clock = timer.querySelector("[data-tm-checkout-clock]");
  var announce = timer.querySelector("[data-tm-checkout-announce]");
  if (!clock) return;

  var minutes = parseInt(timer.getAttribute("data-minutes"), 10);
  if (isNaN(minutes) || minutes < 1) minutes = 15;
  var timeoutUrl = timer.getAttribute("data-timeout-url") || "/";

  /* One key per basket: emptying or changing the cart starts a new hold. */
  var key = "tm-checkout-deadline";
  var deadline = 0;

  function readStore(name) {
    try {
      return window.sessionStorage.getItem(name);
    } catch (e) {
      return null;
    }
  }

  function writeStore(name, value) {
    try {
      window.sessionStorage.setItem(name, value);
    } catch (e) {
      /* A private window can refuse to store, in which case the countdown simply restarts on a reload. */
    }
  }

  var stored = parseInt(readStore(key), 10);
  var now = Date.now();
  if (!isNaN(stored) && stored > now && stored - now <= minutes * 60000) {
    deadline = stored;
  } else {
    deadline = now + minutes * 60000;
    writeStore(key, String(deadline));
  }

  /* Focus without scrolling: a sheet that is still translated off screen would otherwise drag the whole
   * page across as the browser brings the focused control into view. */
  function focusQuietly(node) {
    if (!node || typeof node.focus !== "function") return;
    try {
      node.focus({ preventScroll: true });
    } catch (e) {
      node.focus();
    }
  }

  function two(n) {
    return n < 10 ? "0" + n : String(n);
  }

  var lastAnnounced = -1;

  function tick() {
    var left = Math.round((deadline - Date.now()) / 1000);
    if (left < 0) left = 0;

    var mins = Math.floor(left / 60);
    var secs = left % 60;
    clock.textContent = two(mins) + ":" + two(secs);

    /* Announced at five minutes and at one, not every second, which would drown a screen reader. */
    if (announce && (left === 300 || left === 60) && left !== lastAnnounced) {
      lastAnnounced = left;
      announce.textContent = mins + " minutes left to complete your order";
    }

    if (left === 0) {
      window.clearInterval(handle);
      timer.setAttribute("data-expired", "true");
      if (announce) announce.textContent = "Your basket has expired";
      release();
    }
  }

  /* A hold that runs out has to let the tickets go, otherwise the countdown is decoration: the lines it
   * covered go back to zero and only then does the visitor move on. Merch in the same basket is left
   * alone. If the update fails the visitor still moves on rather than being stranded on a dead clock. */
  function release() {
    var raw = timer.getAttribute("data-release-ids") || "";
    var ids = raw.split(",");
    var updates = {};
    var count = 0;
    for (var i = 0; i < ids.length; i += 1) {
      var id = ids[i].replace(/^\s+|\s+$/g, "");
      if (!id) continue;
      updates[id] = 0;
      count += 1;
    }

    try {
      window.sessionStorage.removeItem(key);
    } catch (e) {
      /* Nothing to clean up if the store refused to hold it in the first place. */
    }

    if (!count) {
      window.location = timeoutUrl;
      return;
    }

    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ updates: updates })
    }).then(
      function () {
        window.location = timeoutUrl;
      },
      function () {
        window.location = timeoutUrl;
      }
    );
  }

  tick();
  var handle = window.setInterval(tick, 1000);

  /* The event limit covers the whole date, not one ticket type, so two boxes that each stop at what the
   * other leaves still add up past it when both are raised. On submit the group is summed and trimmed from
   * the last box back until it fits, which is the only place the total can be seen at once. */
  var updateForm = document.querySelector(".tm-checkout__form");
  if (updateForm) {
    updateForm.addEventListener("submit", function () {
      var boxes = updateForm.querySelectorAll("[data-event]");
      var groups = {};
      for (var i = 0; i < boxes.length; i += 1) {
        var key = boxes[i].getAttribute("data-event");
        if (!groups[key]) groups[key] = [];
        groups[key].push(boxes[i]);
      }
      for (var key2 in groups) {
        if (!Object.prototype.hasOwnProperty.call(groups, key2)) continue;
        var group = groups[key2];
        var limit = parseInt(group[0].getAttribute("data-event-limit"), 10);
        if (isNaN(limit) || limit < 1) continue;
        var total = 0;
        for (var j = 0; j < group.length; j += 1) total += parseInt(group[j].value, 10) || 0;
        for (var k = group.length - 1; k >= 0 && total > limit; k -= 1) {
          var value = parseInt(group[k].value, 10) || 0;
          var over = total - limit;
          var take = value < over ? value : over;
          group[k].value = String(value - take);
          total -= take;
        }
      }
    });
  }

  /* The optional extras: a tick adds the product to the same basket and the page reloads so the totals and
   * the line list come back from Shopify rather than being guessed at in the browser. */
  var extraButtons = document.querySelectorAll("[data-tm-checkout-extra]");
  for (var e = 0; e < extraButtons.length; e += 1) {
    extraButtons[e].addEventListener("click", function (event) {
      var button = event.currentTarget;
      var variant = button.getAttribute("data-tm-checkout-extra");
      if (!variant) return;
      button.disabled = true;
      /* add.js, because change.js only edits a line that already exists and would add nothing. Stacking is
       * prevented elsewhere: the Add button is replaced by Remove once the extra is in the basket, and the
       * quantity box on an extra line stops at one. */
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: variant, quantity: 1 }] })
      }).then(
        function (response) {
          if (!response || !response.ok) {
            button.disabled = false;
            return;
          }
          window.location.reload();
        },
        function () {
          button.disabled = false;
        }
      );
    });
  }

  /* The "What's this?" note behind the circled icon. Closes on Got It, on Escape and on a click outside,
   * the three ways the original lets it go. */
  var help = timer.querySelector("[data-tm-checkout-help]");
  var note = timer.querySelector("[data-tm-checkout-note]");
  var helpClose = timer.querySelector("[data-tm-checkout-help-close]");

  if (help && note) {
    var setOpen = function (open) {
      note.hidden = !open;
      help.setAttribute("aria-expanded", open ? "true" : "false");
    };

    help.addEventListener("click", function (event) {
      event.stopPropagation();
      setOpen(note.hidden);
    });

    if (helpClose) {
      helpClose.addEventListener("click", function () {
        setOpen(false);
        focusQuietly(help);
      });
    }

    document.addEventListener("click", function (event) {
      if (note.hidden) return;
      if (note.contains(event.target) || help.contains(event.target)) return;
      setOpen(false);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !note.hidden) {
        setOpen(false);
        focusQuietly(help);
      }
    });
  }
})();

/* ==== 61-confirmation.js ==== */
/* The page after the purchase (sections/tm-confirmation.liquid) and the basket snapshot that feeds it.
 *
 * Shopify's own thank you page cannot be replaced without Plus, and since 26 August 2026 a non Plus store
 * cannot run a script on it either: Additional scripts is gone from Settings > Checkout and a custom pixel
 * runs in a sandboxed frame that cannot navigate the page it sits on. So the order has to reach
 * /pages/confirmation through the browser, and this file reads it from whichever of the three sources the
 * store actually has, best first:
 *
 *   1. ?order= in the URL, put there by the redirect the owner installs
 *   2. localStorage "tm-confirmation-order", written by that redirect or by a custom pixel
 *   3. localStorage "tm-confirmation-basket", written here from the checkout screen, so the tickets still
 *      list when nothing was installed at all
 *
 * Both stored records use one shape, amounts as decimal strings in the shop's currency:
 *   { number, currency, total, statusUrl, lines: [{ title, variant, quantity, price, linePrice }] }
 *
 * THE REDIRECT. It is not automatic and no theme file can make it so. Where a store still has the box at
 * Settings > Checkout > Order status page > Additional scripts, this goes in it verbatim:
 *
 *   <script>
 *     (function () {
 *       var c = window.Shopify && window.Shopify.checkout;
 *       if (!c) return;
 *       try {
 *         localStorage.setItem("tm-confirmation-order", JSON.stringify({
 *           number: c.order_number,
 *           currency: c.currency,
 *           total: c.total_price,
 *           statusUrl: c.order_status_url,
 *           lines: (c.line_items || []).map(function (l) {
 *             return {
 *               title: l.title,
 *               variant: l.variant_title,
 *               quantity: l.quantity,
 *               price: l.price,
 *               linePrice: l.line_price
 *             };
 *           })
 *         }));
 *       } catch (e) {}
 *       window.location.replace("/pages/confirmation?order=" + encodeURIComponent(c.order_number));
 *     })();
 *   </script>
 *
 * Where that box is gone, a custom pixel at Settings > Customer events can still write the record but not
 * redirect, so the buyer reaches the page by a link. Either way the page renders without it. */
(function () {
  "use strict";

  var ORDER_KEY = "tm-confirmation-order";
  var BASKET_KEY = "tm-confirmation-basket";

  function readStore(name) {
    try {
      return window.localStorage.getItem(name);
    } catch (e) {
      /* A private window can refuse to read, in which case the page falls back to the next source. */
      return null;
    }
  }

  function writeStore(name, value) {
    try {
      window.localStorage.setItem(name, value);
    } catch (e) {
      /* Nothing to do: the snapshot is a convenience, the confirmation email is the record. */
    }
  }

  function readRecord(name) {
    var raw = readStore(name);
    if (!raw) return null;
    try {
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === "object" ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  /* The checkout screen, sections/tm-cart.liquid. The basket is read from Shopify rather than from the
   * rendered rows, so the snapshot carries the same numbers the checkout will charge. A quantity typed
   * into a row and not applied with Update is not in the basket yet, so it is not in the snapshot either. */
  var checkoutForm = document.querySelector(".tm-checkout__form");
  if (checkoutForm) {
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (response) {
        return response && response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return;
        writeStore(
          BASKET_KEY,
          JSON.stringify({
            currency: cart.currency,
            /* cart.js counts in the currency's minor unit, the stored shape is decimal. */
            total: cart.total_price,
            lines: cart.items.map(function (item) {
              return {
                title: item.product_title,
                variant: item.variant_title,
                quantity: item.quantity,
                price: item.price,
                linePrice: item.final_line_price
              };
            })
          })
        );
      })
      .catch(function () {
        /* An offline basket is not worth an error on the checkout screen. */
      });
  }

  var page = document.querySelector("[data-tm-confirmation]");
  if (!page) return;

  var order = readRecord(ORDER_KEY);
  var basket = readRecord(BASKET_KEY);

  var reference = "";
  try {
    reference = new URLSearchParams(window.location.search).get("order") || "";
  } catch (e) {
    reference = "";
  }
  if (!reference && order && order.number) reference = String(order.number);

  /* A record left by an earlier order must not be dressed up as this one: when the URL names an order the
   * stored record does not, only the number from the URL is trusted and the lines are left to the basket. */
  var record = null;
  if (order && (!reference || !order.number || String(order.number) === reference)) {
    record = order;
  } else if (basket) {
    record = basket;
  }

  var currency = (record && record.currency) || "";

  /* Everything reaching here is in the shop's minor unit: Shopify hands cents both in the order record the
   * status page writes and in /cart.js, so the divide belongs here, once, rather than at each caller. */
  function money(amount) {
    var value = parseFloat(amount);
    if (isNaN(value)) return "";
    value = value / 100;
    if (currency) {
      try {
        return new Intl.NumberFormat(undefined, { style: "currency", currency: currency }).format(value);
      } catch (e) {
        /* An unknown currency code falls through to the plain number rather than throwing the page away. */
      }
    }
    return value.toFixed(2);
  }

  function show(element) {
    if (element) element.hidden = false;
  }

  var referenceRow = page.querySelector("[data-tm-confirmation-reference]");
  var referenceValue = page.querySelector("[data-tm-confirmation-order]");
  /* Shopify's sequence starts at 1001 and cannot be moved, so the reference is offset before it is shown.
   * The record in the admin keeps its real number, and the email adds the same offset. */
  function withOffset(value) {
    var raw = String(value).replace(/^#/, "");
    if (!/^\d+$/.test(raw)) return String(value);
    var offset = parseInt(referenceRow && referenceRow.getAttribute("data-number-offset"), 10);
    if (isNaN(offset)) offset = 0;
    return String(parseInt(raw, 10) + offset);
  }

  if (reference && referenceValue) {
    referenceValue.textContent = "#" + withOffset(reference);
    show(referenceRow);
  }

  var list = page.querySelector("[data-tm-confirmation-lines]");
  var lines = (record && record.lines) || [];
  if (list && lines.length) {
    for (var i = 0; i < lines.length; i += 1) {
      var line = lines[i];
      var item = document.createElement("li");
      item.className = "tm-checkout__line";

      var text = document.createElement("div");
      text.className = "tm-checkout__line-text";

      var name = document.createElement("span");
      name.className = "tm-checkout__line-name";
      name.textContent = line.title || "";
      text.appendChild(name);

      /* A single variant extra has Shopify's placeholder title, which is not worth a line. */
      if (line.variant && line.variant !== "Default Title") {
        var variant = document.createElement("span");
        variant.className = "tm-checkout__line-variant";
        variant.textContent = line.variant;
        text.appendChild(variant);
      }

      var unit = document.createElement("span");
      unit.className = "tm-checkout__line-unit";
      var quantity = parseInt(line.quantity, 10);
      if (isNaN(quantity) || quantity < 1) quantity = 1;
      unit.textContent = quantity > 1 ? quantity + " x " + money(line.price) : money(line.price) + " each";
      text.appendChild(unit);

      var side = document.createElement("div");
      side.className = "tm-checkout__line-side";
      var total = document.createElement("span");
      total.className = "tm-checkout__line-total";
      total.textContent = money(line.linePrice);
      side.appendChild(total);

      item.appendChild(text);
      item.appendChild(side);
      list.appendChild(item);
    }
    show(list);
  }

  var totalRow = page.querySelector("[data-tm-confirmation-total-row]");
  var totalValue = page.querySelector("[data-tm-confirmation-total]");
  if (record && record.total && totalValue) {
    totalValue.textContent = money(record.total);
    show(totalRow);
  }

  /* Shopify's order status page is the record of the order, so the link goes there when its URL travelled
   * with the redirect. Without it the page offers no link it cannot honour. */
  var status = page.querySelector("[data-tm-confirmation-status]");
  if (status && record && record.statusUrl) {
    status.setAttribute("href", record.statusUrl);
    show(status);
  }

  if (!reference && !lines.length) {
    show(page.querySelector("[data-tm-confirmation-note]"));
  }
})();

/* ==== 62-order-lookup.js ==== */
/* Your order (sections/tm-order-lookup.liquid). The confirmation email's button carries the order itself,
 * base64url of a small json object in ?o=, because a Shopify page cannot read an order: Liquid has no
 * `order` object outside the notification templates and the Storefront API has no guest lookup. Possession
 * of the link is the access, the same way Shopify's own order status url works.
 *
 * The number in the payload is already the offset one the buyer reads in the email, so it is printed as it
 * arrives. Nothing here is trusted for anything but display. */
(function () {
  "use strict";

  var page = document.querySelector("[data-tm-lookup]");
  if (!page) return;

  var result = page.querySelector("[data-tm-lookup-result]");
  var empty = page.querySelector("[data-tm-lookup-empty]");
  var numberOut = page.querySelector("[data-tm-lookup-number-out]");
  var countOut = page.querySelector("[data-tm-lookup-count]");
  var lines = page.querySelector("[data-tm-lookup-lines]");
  var totalOut = page.querySelector("[data-tm-lookup-total]");

  function decode(value) {
    /* base64url from Liquid: the two swapped characters and any missing padding come back first. */
    var text = String(value).replace(/-/g, "+").replace(/_/g, "/");
    while (text.length % 4 !== 0) text += "=";
    var binary = window.atob(text);
    /* The titles carry accents, so the bytes have to be read as UTF-8 rather than latin-1. */
    var bytes = new Uint8Array(binary.length);
    for (var i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
    return JSON.parse(new TextDecoder("utf-8").decode(bytes));
  }

  var order = null;
  try {
    var raw = new URLSearchParams(window.location.search).get("o");
    if (raw) order = decode(raw);
  } catch (e) {
    order = null;
  }

  if (!order || !order.l || !order.l.length) return;

  function money(amount, currency) {
    var value = parseFloat(amount);
    if (isNaN(value)) return "";
    /* The email sends the shop's minor unit, the same as everywhere else in the clone. */
    value = value / 100;
    try {
      return new Intl.NumberFormat(undefined, { style: "currency", currency: currency || "USD" }).format(value);
    } catch (e) {
      return value.toFixed(2);
    }
  }

  function span(className, text) {
    var node = document.createElement("span");
    node.className = className;
    node.textContent = text;
    return node;
  }

  function row(line, currency) {
    var li = document.createElement("li");
    li.className = "tm-checkout__line";

    var text = document.createElement("div");
    text.className = "tm-checkout__line-text";
    text.appendChild(span("tm-checkout__line-name", line.t || ""));
    if (line.v && line.v !== "Default Title") text.appendChild(span("tm-checkout__line-variant", line.v));
    if (line.d) text.appendChild(span("tm-checkout__line-unit", line.d));
    if (line.w) text.appendChild(span("tm-checkout__line-unit", line.y ? line.w + ", " + line.y : line.w));

    var side = document.createElement("div");
    side.className = "tm-checkout__line-side";
    side.appendChild(span("tm-checkout__line-total", money(line.p, currency)));
    side.appendChild(span("tm-checkout__line-variant", "× " + line.q));

    li.appendChild(text);
    li.appendChild(side);
    return li;
  }

  if (numberOut) numberOut.textContent = "#" + order.n;

  /* Tickets first, extras after, and the ticket count said plainly: it is the thing the buyer came for. */
  var tickets = [];
  var extras = [];
  for (var i = 0; i < order.l.length; i += 1) (order.l[i].x ? extras : tickets).push(order.l[i]);

  var ticketCount = 0;
  for (var j = 0; j < tickets.length; j += 1) ticketCount += tickets[j].q || 0;

  if (countOut && ticketCount > 0) {
    var concert = tickets[0].t || "";
    countOut.textContent = ticketCount === 1 ? "1 ticket for " + concert : ticketCount + " tickets for " + concert;
    countOut.hidden = false;
  }

  if (lines) {
    lines.innerHTML = "";
    var ordered = tickets.concat(extras);
    for (var k = 0; k < ordered.length; k += 1) lines.appendChild(row(ordered[k], order.c));
  }

  if (totalOut) totalOut.textContent = money(order.t, order.c);

  /* Apple Wallet and Google Wallet live in the Event Pass app, reached through its proxy on this domain.
   * The order id travels in the link as `i`; without it there is nothing to point at, so the block stays
   * hidden rather than sending the visitor to an error. */
  var wallet = page.querySelector("[data-tm-lookup-wallet]");
  var walletLink = page.querySelector("[data-tm-lookup-wallet-link]");
  if (wallet && walletLink && order.i) {
    var path = wallet.getAttribute("data-wallet-path") || "/apps/eventpass/tickets";
    walletLink.href = path + "?order=" + encodeURIComponent(order.i);
    wallet.hidden = false;
  }

  if (result) result.hidden = false;
  if (empty) empty.hidden = true;
})();
